import i18n from 'shared/lib/i18n';

import { LOG_EXPORT_REQUEST, SET_MODAL_TYPE } from '../../actionConstants';

import apiClient from '../../apiClient';
import { PROGRESS } from '../Modal/modalTypes';

export const showProgressModal = (
  dispatch,
  isDisplayed,
  id,
  customModalClose,
  title = i18n.t('exports.exporting'),
) =>
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: isDisplayed ? PROGRESS : null,
    modalProps: isDisplayed
      ? {
          title,
          isMinimizeAvailable: true,
          id,
          customModalClose,
        }
      : {},
  });

export const logExport = (dispatch, propertyId, action) =>
  dispatch({
    type: LOG_EXPORT_REQUEST,
    withoutLoading: true,
    payload: apiClient.exports.logExport(propertyId, { action }),
  });
